import tvgConf from "@tvg/conf";
import { get } from "lodash";
import { EnvKey, KeysList } from "./types";

const KEYS_LIST: KeysList = {
  qa: {
    fdr_fe: {
      cpe_web: "client-sJeHwbwoOdpgTjlausdjWW5szEQK3PMG",
      xsell: "client-qx0cXHDe8qz4Usd2HVX6sBJFe14tDTsi"
    },
    tvg: {
      web: "client-jnKlEobFN5VznDxIalCa79Cxx11b03PZ"
    }
  },
  staging: {
    tvg: {
      web: "client-DybuPFka20yiegOqJwv7R3t4TZBFgvzd"
    },
    fdr_fe: {
      cpe_web: "client-sJeHwbwoOdpgTjlausdjWW5szEQK3PMG",
      xsell: "client-qx0cXHDe8qz4Usd2HVX6sBJFe14tDTsi"
    }
  },
  production: {
    fdr_fe: {
      cpe_web: "client-UxgLTJk47Cc6ce5aUb7gcwUvH1tCcDSp",
      xsell: "client-xmgFVJ803S0KiD1UPvsdoAsQFrR1MmTv"
    },
    tvg: {
      web: "client-QWuoGcQ3o0cUyK9IvZLiB3BZZ2eSa6QN"
    }
  }
};

const { environment = "production" } = tvgConf();

export const ENV_KEYS: EnvKey = get(KEYS_LIST, environment, KEYS_LIST.qa);
